import { Directive, Input, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { GroupService } from '../../core/services/group.service';

export interface SpecialtyCondition {
  specialties: string[];
  condition: 'include' | 'exclude';
}

@Directive({
  selector: '[appGroupSpecialtyHide]',
  exportAs: 'appGroupSpecialtyHide'
})
export class GroupSpecialtyHideDirective implements OnInit, OnDestroy {
  @Input('appGroupSpecialtyHide') condition!: SpecialtyCondition;
  
  private destroy$ = new Subject<void>();
  private isHidden = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private groupService: GroupService
  ) {}

  ngOnInit() {
    this.groupService.selectedGroup$
      .pipe(takeUntil(this.destroy$))
      .subscribe(selectedGroup => {
        if (selectedGroup) {
          this.checkSpecialtyCondition(selectedGroup);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkSpecialtyCondition(group: any) {
    if (!this.condition || !group.groupSpeciality) {
      this.showElement();
      return;
    }

    const { specialties, condition } = this.condition;
    const groupSpecialty = group.groupSpeciality;
    const isInList = specialties.includes(groupSpecialty);

    let shouldHide = false;

    if (condition === 'include') {
      // Hide if the group specialty is NOT in the list
      shouldHide = !isInList;
    } else if (condition === 'exclude') {
      // Hide if the group specialty IS in the list
      shouldHide = isInList;
    }

    if (shouldHide) {
      this.hideElement();
    } else {
      this.showElement();
    }
  }

  private hideElement() {
    if (!this.isHidden) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      this.isHidden = true;
    }
  }

  private showElement() {
    if (this.isHidden) {
      this.renderer.removeStyle(this.el.nativeElement, 'display');
      this.isHidden = false;
    }
  }
} 